import React, { Component } from 'react';
//components

//styles
import './scss/main.scss';
import Form from './Form';

const ShareButtonts = (props) => {
    var shareUrl = "https://z.ynet.co.il/short/commerce/2018/poalim70years";
    var negishut = () => {
        document.getElementById('INDmenu-btn').click();
    }
    var shareFacebook = () => {
        
        window.open("https://www.facebook.com/share.php?u=" + shareUrl, '_blank', "width=500,height=300");
        props.sendGA("Share_Facebook", shareUrl);
    }
    var shareTwitter = () => {
        let title = "זאת העמותה שלי";
        let description = "בנק הפועלים, ידיעות אחרונות ו-ynet מזמינים אתכם לספר על העמותה, ארגון או מיזם חברתי שהייתם שותפים לו, או שהכרתם והרשים אתכם."
        let url = 'https://twitter.com/intent/tweet?text=' + title + " " + description + "%0A" + shareUrl;
        window.open(url, '_blank', "width=500,height=300");
        props.sendGA("Share_Twitter", shareUrl);
    }
    return (
        <div className="share-container">
            <ul>
                <li className="twitter" onClick={shareTwitter}></li>
                <li className="facebook" onClick={shareFacebook}></li>
                <li className="accessibility" onClick={negishut}></li>
            </ul>
        </div>
    )
}
const ThxMessage = (props) => {
    return (
        <div className="message-container">
            <div className="thx-image">
                <div className="close-btn" onClick={props.onCloseBtnClick}>
                </div>
            </div>

        </div>
    )
}

class Main extends Component {
    constructor(){
        super();
        this.handlePostFinished = this.handlePostFinished.bind(this);

        this.state = {};
    }

    sendGA(action, label) {
        window.dataLayer.push({
            'event': 'GA_Event',
            'Category': 'poalim70years',
            'Action': action,
            'Label': label
        });
    }

    setStatus(flag) {
        this.setState({ displayMessage: flag });
    }
    handlePostFinished(result){
        this.setStatus(result);
        if(result === true)
            this.sendGA("Form_Sent","");
    }
    render() {
        return (
            <div id="main-container">
                {this.state.displayMessage ? <ThxMessage onCloseBtnClick={() => { this.setStatus(false) }} /> : ""}
                <ShareButtonts sendGA={this.sendGA} />
                <div className="israel-logo" alt="ישראל סיפור הצלחה"></div>
                <div className="seventy-logo" alt="70 שנה למדינת ישראל"></div>
                <Form onPostFinished={this.handlePostFinished}/>
            </div>
        );
    }
}




export default Main;




// WEBPACK FOOTER //
// ./src/Components/Main/Main.js